import { ICellRendererParams } from '@amzn/gft-ag-grid-enterprise';
import { KPI_NAME_INDENT_SPACES } from '@constants/page';
import FootnoteSuperscript from '@deckManagement/components/Page/Footnotes/FootnoteSuperscript';
import InfoIcon from '@mui/icons-material/Info';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { isEmpty } from 'lodash';
import { CSSProperties, memo } from 'react';

const KpiNameCellRenderer = (params: ICellRendererParams) => {
  if (params.value) {
    let displayName = params.value as string;
    let hasNameOverride = false;
    let footnotes: (number | null)[] = [];
    let indentLevel = 0;

    if (params.data?.rawDecklineData) {
      const { rawDecklineData } = params.data;

      // A blank or whitespace-only override falls back to kpi_name, as the Excel export does.
      if (!isEmpty(rawDecklineData.display_name?.trim())) {
        displayName = rawDecklineData.display_name;
        hasNameOverride = true;
      }

      indentLevel = (rawDecklineData.kpi_name_indent_level ?? 0) * KPI_NAME_INDENT_SPACES;

      if (rawDecklineData.footnotes && rawDecklineData.footnotes.length > 0) {
        footnotes = rawDecklineData.footnotes;
      }
    }

    const mainContent = (
      <Box>
        {displayName}
        <FootnoteSuperscript footnotes={footnotes} />
      </Box>
    );

    const displayNameOverrideIcon = (
      <Tooltip title='Display Name Overridden for this Deckline' arrow>
        <Box className='display-kpiName__icon'>
          <InfoIcon fontSize='small' />
        </Box>
      </Tooltip>
    );

    return (
      <Box className='display-kpiName' style={{ '--indent-level': indentLevel } as CSSProperties}>
        {hasNameOverride && (
          <Stack direction='row' spacing={1}>
            {mainContent}
            {displayNameOverrideIcon}
          </Stack>
        )}
        {!hasNameOverride && mainContent}
      </Box>
    );
  }

  return '';
};

export default memo(KpiNameCellRenderer);
